import styled from 'styled-components'
import { brandOrange, brandWhite } from '../../../assets/consts/color'

export const Container = styled.div`
  width: 100%;

  .col-xs-3 {
    padding: 0;
  }

  & > div > div > .item-label {
    position: absolute;
    bottom: 3%;

    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2px;

    text-align: center;
    font-weight: 600;
    color: ${brandWhite};
    background-color: ${brandOrange};

    @media only screen and (min-width: 48em) {
      font-size: 16px;
    }

    @media only screen and (min-width: 64em) {
      font-size: 9px;
    }

    @media only screen and (min-width: 90em) {
      font-size: 12px;
    }

    @media only screen and (min-width: 1551px) {
      font-size: 14px;
    }
  }

  & > div > .graphic-item {
    position: relative;
    display: flex;
    & > div:nth-of-type(1)::before {
      display: none;
    }
  }

  & > div:nth-of-type(1),
  & > div:nth-of-type(4) {
    justify-content: center;
  }

  & > div:nth-of-type(2),
  & > div:nth-of-type(3) {
    justify-content: space-between;
    align-items: center;
  }

  & > div:nth-of-type(3) {
    & > div:nth-of-type(1) {
      transform: rotate(126deg);
    }
  }

  & > div:nth-of-type(1) {
    align-items: end;

    & > div:nth-of-type(1) {
      margin-right: 8%;
    }
    & > div:nth-of-type(2) {
      margin-bottom: 15%;
    }
    & > div:nth-of-type(3) {
      margin-left: 8%;
    }
  }
`
